import { CartItem } from '../features/cart/storage/cart.types'
import { SalesLine, SalesOrder } from '../features/orders/storage/types'
import { addGST } from './addGst'
import { formatPrice } from './helpers'

export const calculateEditedPriceDiscount = (item: CartItem) => {
  if (item?.editedPriceExcGst && item?.originalPriceExcGst) {
    return (item.originalPriceExcGst - item?.editedPriceExcGst) * item.quantity
  }
  return 0
}

const calculateSalesLineDiscount = (item: SalesLine) => {
  if (item?.basePriceExcGst && item?.originalPriceExcGst) {
    return item.originalPriceExcGst * item.quantity - item?.basePriceExcGst
  }
  return 0
}

export const calculateOrderDiscount = (order?: SalesOrder) => {
  const allDiscounts = order?.discountIncGst ?? 0
  const editedItemDiscounts =
    order?.salesLines
      .filter((salesLine) => salesLine.isPriceOverridden)
      .reduce((acc, item) => acc + calculateSalesLineDiscount(item), 0) ?? 0
  const totalDiscount = allDiscounts + addGST(editedItemDiscounts)
  if (totalDiscount === 0) {
    return undefined
  }
  return formatPrice(totalDiscount)
}
